/**
 * Replacement provider flow URL helpers (P0 #4).
 */

export function replacementServicePath(serviceKey, sourceBookingId) {
  if (!serviceKey || !sourceBookingId) return null;
  const search = `?replacement=${encodeURIComponent(sourceBookingId)}`;
  return `/consumer/service/${serviceKey}${search}`;
}

export function hasReplacementEntitlement(booking) {
  return Boolean(
    booking?.replacement_entitlement?.available &&
      booking?.replacement_entitlement?.source_booking_id,
  );
}
